// StandardHeader.js
import { Box, HStack, Heading } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types"; // สำหรับการตรวจสอบประเภทของ props (ถ้าไม่ได้ใช้ TypeScript)

export const StandardPageTitle = ({ title, textColor = "gray.600" }) => {
  const fontSize = "clamp(1.5rem, 1.5vmin, 1.8rem)";
  return (
    <Heading fontSize={fontSize} mb={2} textAlign="start">
      {title}
    </Heading>
  );
};

// ขนาดของแถบหัวเรื่อง
//   md คือขนาดเดิมที่หน้าอื่นใช้อยู่ ใช้กับหัวเรื่องหลักของหน้า
//   sm สำหรับหน้าที่มีหลายแถบซ้อนกัน จะได้ไม่กินพื้นที่จนเนื้อหาถูกดันลงไป
const headerSizes = {
  md: { fontSize: "clamp(1.5rem, 2vmin, 2rem)", padding: 2, spacing: 5, indent: 5, icon: "lg" },
  sm: { fontSize: "clamp(1rem, 1.4vmin, 1.25rem)", padding: 2, spacing: 3, indent: 3, icon: "sm" },
};

export const StandardHeader = ({
  title,
  bgColor,
  icon,
  textColor = "white", // ค่า default หากไม่ได้ส่งมา
  iconColor = "white", // ค่า default หากไม่ได้ส่งมา
  iconSize, // ถ้าไม่ส่งมาจะใช้ขนาดที่คู่กับ size
  size = "md",
  ...rest
}) => {
  const preset = headerSizes[size] || headerSizes.md;
  return (
    <Box
      borderRadius="2xl" // คุณสามารถปรับ borderRadius ตามต้องการ เช่น "md", "lg"
      w="100%"
      bgColor={bgColor}
      color={textColor}
      px={preset.padding}
      py={size === "sm" ? 1.5 : preset.padding}
      boxShadow="md" // เพิ่มเงาเล็กน้อยเพื่อความสวยงาม (optional)
      {...rest}
    >
      <HStack spacing={preset.spacing} ml={preset.indent}>
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            color={iconColor}
            size={iconSize || preset.icon}
          />
        )}
        <Heading
          as="h1"
          size={{ base: "md", md: "md" }}
          fontSize={preset.fontSize}
          fontWeight="normal"
          noOfLines={2}
        >
          {title}
        </Heading>
      </HStack>
    </Box>
  );
};

// กำหนด PropTypes เพื่อการตรวจสอบ (ถ้าไม่ได้ใช้ TypeScript)
StandardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired, // FontAwesome icon object
  textColor: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
};
